import React, { useState } from 'react'
import './who_we_are.css'
import Common_title from '../../common_components/common-title/Common_title'
import Red_Btn from '../../common_components/common_btn/red_btn/Red_Btn'
import Enquiry_Form_Modal from '../../common_components/common_modal/Enquiry_Form_Modal/Enquiry_Form_Modal'

const Who_we_are = () => {

    const [showModal, setShowModal] = useState(false)

    return (
      <>
        <section className="Who_we_are_sec">
          <div className="container-lg">
            <div className="row justify-content-center">
              <div className="col-sm-6 col-8 ">
                <div className="img-sec">
                  <img
                    className="studentimg"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/home/who-we-are/dypatil.png"
                    }
                  />
                </div>
              </div>
              <div className="col-md-6 my-auto ">
                <div className="content-sec ps-md-3 ps-0">
                  <Common_title
                    className="text-left"
                    title="Discover Who We Are?"
                    subtitle="India’s Leading Online Deemed-to-be University"
                  />

                  <p className="abt_dpu">
                    At Dr. D.Y. Patil Vidyapeeth's Centre for Online Learning
                    (DPU-COL), we’re redefining education through innovative,
                    industry-aligned online programs. Designed by experts &
                    backed by top accreditations, our courses offer globally
                    recognized, career-focused learning that connects academic
                    excellence with real-world success.
                  </p>

                  <div className="row">
                    <div className="col-sm-6 col-12 mb-2">
                      <div className="flexuni">
                        <div className="icondiv">
                          <img
                            className="icon"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/home/who-we-are/university.png"
                            }
                          />
                        </div>
                        <div className="textdiv">
                          <p>University Mission Statement</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6 col-12 mb-2">
                      <div className="flexuni">
                        <div className="icondiv">
                          <img
                            className="icon"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/home/who-we-are/school.png"
                            }
                          />
                        </div>
                        <div className="textdiv">
                          <p>University Vision Achievement</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="ranked_div">
              <div className="row">
                <div className="col-6 text-center bd-right">
                  <h1>Ranked #1</h1>
                  <p>Among Online & Distance Learning Institutes</p>
                </div>
                <div className="col-6 text-center">
                  <h1>40 Years</h1>
                  <p>of Consistent Excellence</p>
                </div>
              </div>
            </div>

            <div className="btn_holder">
              <Red_Btn
                btn_name="Enquire Now"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              />
              {/* <Red_Btn btn_name="DOWNLOAD BROCHURE" onClick={() => { setShowModal(true) }} /> */}
            </div>
          </div>

          <Enquiry_Form_Modal
            show={showModal}
            onHide={() => {
              setShowModal(false);
            }}
          />
        </section>
      </>
    );
}

export default Who_we_are